/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Rules_DescriptionInputs */



/**
* | output |
* | --- |
* | "Core and tournament rules" |
*
* @param {Nav_Rules_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_rules_description = /** @type {((inputs?: Nav_Rules_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Rules_DescriptionInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Grund- und Turnierregeln")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Règles de base et de tournoi")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("核心规则与赛事规则")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("核心規則與賽事規則")
	if (locale === "ko") return /** @type {LocalizedString} */ ("핵심 규칙과 대회 규정")
	return /** @type {LocalizedString} */ ("Core and tournament rules")
});